import { render, staticRenderFns } from "./resend-activation.vue?vue&type=template&id=f74ca2be&scoped=true&"
import script from "./resend-activation.vue?vue&type=script&lang=js&"
export * from "./resend-activation.vue?vue&type=script&lang=js&"
import style0 from "./resend-activation.vue?vue&type=style&index=0&id=f74ca2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74ca2be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
